export const CAREERTREE_CHECKOUT_RETURN_STORAGE_KEY = 'careertree-login-return-to';
export const CAREERTREE_PRO_CHECKOUT_RETURN_TO = '/app/pricing?checkout=pro';

export function isCareerTreeProCheckoutReturn(value: string | null | undefined) {
  return value === CAREERTREE_PRO_CHECKOUT_RETURN_TO;
}

export function getCareerTreeAnonymousOnboardingId() {
  const key = 'careertree_anonymous_onboarding_id';
  if (typeof window === 'undefined') return null;
  const existing = window.localStorage.getItem(key);
  if (existing) return existing;
  const nextId = window.crypto?.randomUUID?.() ?? `anon-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  window.localStorage.setItem(key, nextId);
  return nextId;
}

export function sendCareerTreeOnboardingEvent(payload: {
  anonymousId?: string | null;
  eventName: string;
  step: string;
  metadata?: Record<string, unknown> | null;
}) {
  if (typeof window === 'undefined') return false;
  const body = JSON.stringify(payload);
  const url = '/api/v1/careertree/onboarding/events';
  if (navigator.sendBeacon) {
    const sent = navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    if (sent) return true;
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => undefined);
  return true;
}
